import { Component, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { WithdrawalService } from '../../services/withdrawal.service';
import { SiteFooterComponent } from '../site-footer/site-footer.component';

@Component({
  selector: 'app-public-withdrawal',
  imports: [RouterLink, SiteFooterComponent],
  templateUrl: './public-withdrawal.component.html',
})
export class PublicWithdrawalComponent {
  private withdrawalService = inject(WithdrawalService);

  readonly updated = '20 de mayo de 2026';

  readonly fullName = signal('');
  readonly email = signal('');
  readonly bookingId = signal('');
  readonly loading = signal(false);
  readonly success = signal(false);
  readonly error = signal<string | null>(null);

  onFullNameInput(event: Event): void {
    this.fullName.set((event.target as HTMLInputElement).value);
  }

  onEmailInput(event: Event): void {
    this.email.set((event.target as HTMLInputElement).value);
  }

  onBookingIdInput(event: Event): void {
    this.bookingId.set((event.target as HTMLInputElement).value);
  }

  canSubmit(): boolean {
    return !!this.fullName().trim()
      && !!this.email().trim()
      && !!this.bookingId().trim()
      && !this.loading();
  }

  async submit(): Promise<void> {
    if (!this.canSubmit()) return;

    this.loading.set(true);
    this.error.set(null);
    try {
      await this.withdrawalService.submitPublic({
        fullName: this.fullName(),
        email: this.email(),
        bookingId: this.bookingId(),
      });
      this.success.set(true);
    } catch (err: unknown) {
      const code = (err as { code?: string })?.code;
      const message = (err as { message?: string })?.message;
      if (code === 'functions/already-exists') {
        this.error.set('Ya existe una solicitud de desistimiento para esta reserva.');
      } else if (message) {
        this.error.set(message);
      } else {
        this.error.set('No se pudo enviar la solicitud. Inténtalo de nuevo.');
      }
    } finally {
      this.loading.set(false);
    }
  }
}
